import { gql } from 'apollo-boost';

export const RETRY_ADMIN_AUDIO_TRANSCRIPTION_JOBS = gql`
    mutation RetryAdminAudioTranscriptionJobs($data: RetryAdminAudioTranscriptionJobsInput) {
        retryAdminAudioTranscriptionJobs(data: $data) {
            matchedCount
            modifiedCount
            requestIds
        }
    }
`;
